export default {
  SHOW: '@WS_EDITOR/CUSTOM_UI/SHOW',
  HIDE: '@WS_EDITOR/CUSTOM_UI/HIDE',
};
